import { PureComponent } from 'react';
import { addFlux, AddFluxHOCProps } from 'components/wrappers/WithFlux';
import FuzzyLocationResults from 'utils/FuzzyLocationResults';
import Analytics from '@withlocals/withlocals-analytics';
import debounce from 'lodash.debounce';
import { keywords } from 'data/keywords';
import { SearchMode } from 'model/Filters';
import { isCordova } from 'utils/platform';

interface LocationSuggestionsProviderState {
  suggestions?: any;
  recentSearches?: any;
  popularLocations?: any;
  approvedLocations?: any;
}

interface LocationSuggestionsProviderProps extends Partial<AddFluxHOCProps> {
  value?: string;
  children: (e: LocationSuggestionsProviderState) => any;
}

class LocationSuggestionsProvider extends PureComponent<LocationSuggestionsProviderProps & AddFluxHOCProps, LocationSuggestionsProviderState> {
  state = this.getStateFromStore();

  sendNotFoundCitiesToAnalytics = debounce(() => {
    Analytics.track('Search page', 'City not found', {
      city: this.props.value,
    });
  }, 500);

  enablePlacesSearch() {
    return this.props.flux.stores.FiltersStore.getSearchMode() !== SearchMode.LOCALS && !isCordova();
  }

  componentDidMount() {
    this.props.flux.stores.LocationsStore.on('change', this.onStoreChange);
    this.props.flux.actions.locations.fetchTopDestinations();
  }

  componentWillUnmount() {
    this.props.flux.stores.LocationsStore.removeListener('change', this.onStoreChange);
  }

  getStateFromStore() {
    return {
      approvedLocations: this.props.flux.stores.LocationsStore.getApprovedLocations().data,
      suggestions: [],
      recentSearches: this.props.flux.stores.SearchStore.getRecentSearches(),
      popularLocations: this.props.flux.stores.LocationsStore.getTopDestinations().data.slice(0, 10)
    };
  }

  onStoreChange = () => {
    this.setState(this.getStateFromStore());
  };

  componentWillUpdate(nextProps) {
    if (nextProps.value && nextProps.value !== this.props.value) {
      const locations = this.props.flux.stores.LocationsStore.getApprovedLocations().data ?? [];
      const places = this.enablePlacesSearch() ? keywords : [];
      const fuzzyResults = FuzzyLocationResults(locations, places).search(nextProps.value);
      const suggestions = fuzzyResults.slice(0, 7);
      this.setState({
        suggestions: suggestions.map(suggestion => suggestion.item) ?? [],
      });
      if (suggestions.length === 0 && this.props.value.length > 2) {
        this.sendNotFoundCitiesToAnalytics();
      }
    }
  }

  render() {
    return this.props.children({ ...this.state });
  }
}

export default addFlux(LocationSuggestionsProvider);
